import {
  Component,
  OnChanges,
  input,
  ChangeDetectionStrategy
} from '@angular/core';

import { ApplicantStatus, PropertyType } from '@ui/shared/model';
import { StatusPipelineBaseComponent } from '../status-pipeline-base.component';
import {
  CurrentStatusConfig,
  PipelineSteps
} from '../status-pipeline-base.config';
import {
  APPLICATION_STATUS_CONFIGS,
  unknownApplicationStatusConfig
} from '../../../../config/status-pipeline.config';
import { applicationSteps } from './application-status-pipeline.config';

@Component({
  selector: 'app-application-status-pipeline',
  templateUrl: './application-status-pipeline.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [StatusPipelineBaseComponent]
})
export class ApplicationStatusPipelineComponent implements OnChanges {
  // Callers read the status off beans that type it as a plain string.
  readonly status = input<ApplicantStatus | string | null>();
  readonly pageView = input<boolean>();
  readonly propertyType = input<PropertyType>();

  public steps: PipelineSteps;
  public currentStatus: CurrentStatusConfig;

  private getCurrentStatus(): CurrentStatusConfig {
    this.steps = applicationSteps;
    const config =
      APPLICATION_STATUS_CONFIGS[
        this.status() as keyof typeof APPLICATION_STATUS_CONFIGS
      ] || unknownApplicationStatusConfig;
    return {
      ...config,
      pipeline: {
        ...config.pipeline,
        showAsFullscreen: typeof config.pipeline.stepId === 'undefined'
      }
    };
  }

  ngOnChanges(): void {
    this.currentStatus = this.getCurrentStatus();
  }
}
